import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'
import { ContractsAnnualWorkingTimeDistributionEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { WizardData } from '../types'

interface Props {
  fieldName: keyof WizardData
  data: WizardData
  onChangeField: (fieldName: string, value: string) => void
}

export const AnnualWorkingTimeDistributionField = ({ fieldName, data, onChangeField }: Props) => {
  const currentValue = data[fieldName] ?? 'limit_workdays'

  const annualWorkingTimeDistributionOptions: {
    value: ContractsAnnualWorkingTimeDistributionEnum
    label: string
    description: string
  }[] = [
    {
      value: 'limit_workdays',
      label: i18n.t(
        'add_employee_modal.contract_information_step.fields.annual_working_time_distribution.limit_workdays'
      ),
      description: i18n.t(
        'add_employee_modal.contract_information_step.fields.annual_working_time_distribution.limit_workdays_description'
      ),
    },
    {
      value: 'limit_daily_hours',
      label: i18n.t(
        'add_employee_modal.contract_information_step.fields.annual_working_time_distribution.limit_daily_hours'
      ),
      description: i18n.t(
        'add_employee_modal.contract_information_step.fields.annual_working_time_distribution.limit_daily_hours_description'
      ),
    },
  ]

  return (
    <Box gap="s8">
      <Box gap="s2">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t(
            'add_employee_modal.contract_information_step.fields.annual_working_time_distribution.label'
          )}
        </Text.Normal>
      </Box>
      <Box gap="s8">
        {annualWorkingTimeDistributionOptions.map((option) => {
          return (
            <Box key={option.value}>
              <RadioButton
                label={option.label}
                value={option.value}
                checked={String(currentValue) === option.value}
                onChange={() => onChangeField(fieldName, option.value)}
                size="small"
              />
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
